// Copyright 2021 Carnegie Mellon University. All Rights Reserved.
// Released under a MIT (SEI)-style license. See LICENSE.md in the project root for license information.
export enum TopbarView {
  CASTER_ADMIN = 'caster-admin',
  CASTER_HOME = 'caster-home',
  CASTER_PROJECT = 'caster-project',
}
